import Base from './base'
import urls from 'config/urls'

class Common extends Base {
  getQiniuUptoken (opts) {
    return this.httpGet({
      url: urls.common.getQiniuUptoken,
      data: opts
    })
  }
}

export default new Common



// WEBPACK FOOTER //
// ./src/models/common.js